module.exports = __webpack_public_path__ + "media/images/bsmart/icons/send_invite-81b9b341d9f8459d4e93f8abc15358ea.svg";